import DeleteIcon from '@mui/icons-material/Delete';
import { Button, IconButton } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ConfirmationDeleteDialogContent from './ConfirmationDeleteContent';

interface ConfirmationButtonDialogProps {
  id?: number;
  iconButton?: boolean;
  message?: string;
  handleDelete?: (id: number) => void;
}

export default function ConfirmationButtonDialog({
  id,
  iconButton,
  message,
  handleDelete
}: ConfirmationButtonDialogProps) {
  const { t } = useTranslation();

  const [openDialog, setOpenDialog] = useState(false);

  const handleOpenDialog = () => setOpenDialog(true);
  const handleCloseDialog = () => setOpenDialog(false);

  const handleConfirmDelete = () => {
    handleDelete(id ? id : null);

    // Close the dialog and reset the selected row ID.
    setOpenDialog(false);
  };

  return (
    <>
      {iconButton ? (
        <IconButton
          id="delete-action-button"
          onClick={handleOpenDialog}
          color="error"
          size="small"
          sx={{
            '&:hover': {
              backgroundColor: 'error.lighter'
            }
          }}>
          <DeleteIcon />
        </IconButton>
      ) : (
        <Button onClick={handleOpenDialog} color="error">
          <DeleteIcon /> {t('actions.delete')}
        </Button>
      )}
      <ConfirmationDeleteDialogContent
        openDialog={openDialog}
        message={message}
        handleCloseDialog={handleCloseDialog}
        handleConfirmDelete={handleConfirmDelete}
      />
    </>
  );
}
